import { render, staticRenderFns } from "./ManageLoyalty.vue?vue&type=template&id=c924b0de&scoped=true&"
import script from "./ManageLoyalty.vue?vue&type=script&lang=ts&"
export * from "./ManageLoyalty.vue?vue&type=script&lang=ts&"
import style0 from "./ManageLoyalty.vue?vue&type=style&index=0&id=c924b0de&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c924b0de",
  null
  
)

export default component.exports